import type { HttpRequest } from '@angular/common/http';
import { HttpResponse, type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { take, tap } from 'rxjs/operators';

import type { UserCounts } from '../models/user';
import { selectUserCounts } from '../store';
import { setUserCounts, updateUserCounts } from '../store/user-info/user-info.actions';

export const patchUserCountsInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject<Store>(Store);

  return next(req).pipe(
    tap(event => {
      if (!(event instanceof HttpResponse)) {
        return;
      }
      checkCounts(req, store);
    }),
  );
};

function checkCounts(req: HttpRequest<unknown>, store: Store) {
  const test = (url: string) => RegExp(url).test(req.url);
  const updateCountsFromServer = () => store.dispatch(setUserCounts());
  store
    .select(selectUserCounts)
    .pipe(
      take(1),
      tap((currentCounts: UserCounts) => {
        const update = (countName: keyof UserCounts, value: number, isAdding = true) => {
          store.dispatch(
            updateUserCounts({
              countName: countName,
              countValue: isAdding ? currentCounts[countName] + value : currentCounts[countName] - value,
            }),
          );
        };
        switch (req.method.toUpperCase()) {
          case 'POST':
            if (test('/api/monitoringitem/bulk-delete/') && Array.isArray(req.body)) {
              update('owned_monitoringitems', req.body.length, false);
            }
            break;
          case 'DELETE':
            if (test('/api/monitoringitem/delete-all/')) {
              updateCountsFromServer();
            }
            break;
          case 'PUT':
            if (test('/api/monitoringitem/add/')) {
              updateCountsFromServer();
            }
        }
      }),
    )
    .subscribe();
}
